import 'react-app-polyfill/ie11'
import LoadingOverlay from '../src/components/loading/LoadingOverlay'
//import * as serviceWorker from './serviceWorker';
import {PublicClientApplication} from '@azure/msal-browser'
import {MsalProvider} from '@azure/msal-react'
import ReactDOM from 'react-dom'

import React from 'react'
import {BrowserRouter, Switch} from 'react-router-dom'
import ScrollToTop from '../src/utils/ScrollToTop'
import Main from './Main'
import {
    getAccessToken,
    getTacAcceptance,
    isAuthenticated,
} from './components/authentication/AuthUtils'
import Authentication from './components/authentication/Authentication'
import CoolDown from './components/error/CoolDown'
import LoadingScreen from './components/loading/LoadingScreen'
import Notification from './components/notification/Notification'
import RequestAccess from './components/request-access/RequestAccess'
import TermsAndCondition from './components/terms-and-condition/TermsAndCondition'
import axiosInstance from './config/AxiosConfig'
import './i18n/i18nConfig'
import {msalConfig} from './sso/SSOConfig'

isAuthenticated()
    ? (axiosInstance.defaults.headers.common[
          'Authorization'
      ] = `Bearer ${getAccessToken()}`)
    : delete axiosInstance.defaults.headers.common['Authorization']
const msalInstance = new PublicClientApplication(msalConfig)

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Switch>
                <ScrollToTop>
                    <LoadingScreen />

                    <MsalProvider instance={msalInstance}>
                        {isAuthenticated() ? (
                            !getTacAcceptance() ? (
                                <TermsAndCondition />
                            ) : (
                                <Main />
                            )
                        ) : (
                            <Authentication type={'login'} />
                        )}
                    </MsalProvider>
                    <RequestAccess />
                    <CoolDown />
                    <Notification />
                    <LoadingOverlay />
                </ScrollToTop>
            </Switch>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
